import { AxiosInstance } from 'axios'
import { MenuItem } from './menu'

const PRODUCT_URL = 'menu'

export const makeMenuService = (api: AxiosInstance) => ({
  getMenuItems: (): Promise<MenuItem[]> =>
    api.get(PRODUCT_URL).then((response) => response.data),
})
